import { Flex, Text, useMantineTheme, Tabs } from "@mantine/core";
import { useContext, useEffect, useState } from "react";
import { AppContext } from "src/api/AppContext";
import { CLIENT_TAB_LIST } from "src/utils/constants";
import useAppMain from "src/hooks/useAppMain";
import Credits from "./Credits";
import Agreements from "./Agreements";
import {
  useGetSignedAgreementsLazyQuery,
  useGetCreditAllotmentManyLazyQuery,
} from "src/generated/graphql";

const Accounts = () => {
  useAppMain(CLIENT_TAB_LIST.MY_ACCOUNTS, false);
  const theme = useMantineTheme();
  const { currentClient } = useContext(AppContext);

  const [getAgreements, { data: agreementData }] =
    useGetSignedAgreementsLazyQuery({
      variables: {
        clientId: currentClient?.id || "",
      },
      fetchPolicy: "no-cache",
    });

  const [getCredits, { data: creditsData }] =
    useGetCreditAllotmentManyLazyQuery({
      variables: {
        clientId: currentClient?.id || "",
      },
      fetchPolicy: "no-cache",
    });

  const CLIENT_ACCOUNT_TABS = [
    {
      label: "Credits",
      value: "credits",
      component: (
        <Credits creditsData={creditsData?.creditAllotmentMany || []} />
      ),
    },
    {
      label: "Agreements",
      value: "agreements",
      component: (
        <Agreements agreementData={agreementData?.signedAgreementMany || []} />
      ),
    },
  ];

  const [activeTab, setActiveTab] = useState<string | null>(
    CLIENT_ACCOUNT_TABS[0].value
  );

  useEffect(() => {
    if (currentClient) {
      getCredits();
      getAgreements();
    }
  }, [currentClient]);

  return (
    <Tabs
      value={activeTab}
      onTabChange={setActiveTab}
      radius="sm"
      defaultValue="Credits"
      sx={{
        ".mantine-Tabs-tab[data-active='true']": {
          fontWeight: 600,
        },
      }}
      styles={(theme) => ({
        tabsList: {
          borderBottom: 0,
          justifyContent: "center",
        },
        tab: {
          minWidth: "38vw",
          color: theme.colors.secondaryTextColor[6],
          fontWeight: 400,
          fontSize: "1em",
        },
      })}
    >
      <Tabs.List grow position="center">
        {CLIENT_ACCOUNT_TABS.map((tab) => (
          <Tabs.Tab
            value={tab.value}
            style={{ color: theme.colors.secondaryTextColor[6] }}
          >
            {tab.label}
          </Tabs.Tab>
        ))}
      </Tabs.List>
      {CLIENT_ACCOUNT_TABS.map((tab) => {
        return (
          <Tabs.Panel value={tab.value} pt={25}>
            {tab.component}
          </Tabs.Panel>
        );
      })}
    </Tabs>
  );
};

export default Accounts;
